import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const entryCategoryConfigurationFields: FieldInterface[] = [
  {
    key: 'entryCategory',
    originKey: 'entry_category',
    type: FIELD_TYPES.string,
  },
  {
    key: 'entryCategoryFrontEnd',
    originKey: 'entry_category_front_end',
    type: FIELD_TYPES.string,
  },
  {
    key: 'entryCategoryOrder',
    originKey: 'entry_category_order',
    type: FIELD_TYPES.number,
  },
]

const entryCategoryConfigurationRelations: RelationInterface[] = []

export { entryCategoryConfigurationFields, entryCategoryConfigurationRelations }
